export const MENTOR_CREATE = "MENTOR_CREATE";
export const MENTOR_CREATE_SUCCESS = "MENTOR_CREATE_SUCCESS";
export const MENTOR_CREATE_ERROR = "MENTOR_CREATE_ERROR";

export const MENTOR_LIST = "MENTOR_LIST";
export const MENTOR_LIST_SUCCESS = "MENTOR_LIST_SUCCESS";
export const MENTOR_LIST_ERROR = "MENTOR_LIST_ERROR";

export const MENTOR_INFO = "MENTOR_INFO";
export const MENTOR_INFO_SUCCESS = "MENTOR_INFO_SUCCESS";
export const MENTOR_INFO_ERROR = "MENTOR_INFO_ERROR";

export const MENTOR_UPDATE_SUCCESS = "MENTOR_UPDATE_SUCCESS";
export const MENTOR_UPDATE_ERROR = "MENTOR_UPDATE_ERROR";

export const MENTOR_DELETE_SUCCESS = "MENTOR_DELETE_SUCCESS";
export const MENTOR_STATUS_UPDATE_SUCCESS = "MENTOR_STATUS_UPDATE_SUCCESS";

export const CLEAR_MENTOR_INFO = "CLEAR_MENTOR_INFO";
